import SpriteSymbol from "../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "checked-circle--sprite",
  "use": "checked-circle--sprite-usage",
  "viewBox": "0 0 16 17",
  "content": "<symbol viewBox=\"0 0 16 17\" xmlns=\"http://www.w3.org/2000/svg\" id=\"checked-circle--sprite\">\n<path d=\"M7.99998 1.83325C4.31998 1.83325 1.33331 4.81992 1.33331 8.49992C1.33331 12.1799 4.31998 15.1666 7.99998 15.1666C11.68 15.1666 14.6666 12.1799 14.6666 8.49992C14.6666 4.81992 11.68 1.83325 7.99998 1.83325ZM6.66665 11.8333L3.33331 8.49992L4.27331 7.55992L6.66665 9.94659L11.7266 4.88659L12.6666 5.83325L6.66665 11.8333Z\" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol